import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["hidden"]

  hide() {
    this.hiddenTargets.forEach(target => target.setAttribute("hidden", true))
  }

  show() {
    this.hiddenTargets.forEach(target => target.removeAttribute("hidden"))
  }
}
